<script>
const script = document.createElement('script')
let cb

script.async = true
script.src = 'https://www.google.com/recaptcha/api.js?render=' + process.env.VUE_APP_RECAPTCHA_KEY + '&onload=onReCaptchaLoad'

window.onReCaptchaLoad = _ => {
    window.grecaptcha.ready(function () {
        cb(window.grecaptcha)
    })
}

export default {
    data() {
        return {
            ready: false
        }
    },

    destroyed() {
        location.reload()
    },

    beforeMount() {
        cb = this.loaded

        this.ready = !!window.grecaptcha

        if (!this.ready || !script.parentNode) {
            document.head.append(script)
        }
    },

    methods: {
        loaded() {
            this.ready = true
            this.$emit('ready')
        },

        async execute(opts) {
            if (!this.ready) {
                return
            }

            try {
                const token = await window.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_KEY, opts || {})
                this.$emit('input', token)
            } catch (e) {
                console.log(e)
            }
        }
    },

    render(h) {
        return h('div')
    }
}
</script>
